// Protected route wrapper - redirects to login if not authenticated
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useCartridgeUI } from '../../hooks/useCartridgeUI'
import { useEffect } from 'react'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, checkAuth } = useAuth()
  const { fetchExtensions } = useCartridgeUI()
  const location = useLocation()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  // Fetch cartridge UI extensions when authenticated
  useEffect(() => {
    if (isAuthenticated) {
      fetchExtensions()
    }
  }, [isAuthenticated, fetchExtensions])

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-emerald-500 border-t-transparent mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    // Redirect to login, preserving the intended destination
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
